export default "__VITE_ASSET__Nko7yFVb__"